// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1Qzjd","col":"Table_col__SCNJh","fulfillmentStatus":"Table_fulfillmentStatus__2xyWj","emailCol":"Table_emailCol__3xc4z"};